<template>
  <el-calendar ref="calendar" v-loading="loading" v-model="date">
    <template #header="{date}">
      <span>{{ date }}</span>
      <el-button-group>
        <el-button size="small" @click="selectDate('prev-year')">
          Previous Year
        </el-button>
        <el-button size="small" @click="selectDate('prev-month')">
          Previous Month
        </el-button>
        <el-button size="small" @click="selectDate('today')">Today</el-button>
        <el-button size="small" @click="selectDate('next-month')">
          Next Month
        </el-button>
        <el-button size="small" @click="selectDate('next-year')">
          Next Year
        </el-button>
      </el-button-group>
    </template>
    <template #date-cell="{data}">
      <div>{{ data.day.split('-').slice(1).join('-') }}</div>
      <div style="height: 80px;" @click="openDialog(data.day)">
        <img style="height: 30px;margin: 2px" :src="resourceUrl(i.thumbnail)"
             v-for="i in data_map[data.day].slice(0, 6)" v-if="data_map[data.day]">
      </div>
    </template>
  </el-calendar>
  <el-dialog v-model="dialog_opened" :before-close="reset" width="80%">
    <el-select v-model="country" filterable :disabled="loading" placeholder="选择国家">
      <el-option value="GLOBAL" label="GLOBAL"></el-option>
      <el-option v-for="c in $root.country_list" :value="c.code"
                 :label="c.en_name + ' (' + c.code + ')'"></el-option>
    </el-select>
    <el-select v-model="platform" filterable placeholder="请选择平台" :disabled="loading" style="width: 140px; margin-left: 10px">
      <el-option v-for="c in ['android', 'ios']" :value="c" :label="c"></el-option>
    </el-select>

    <el-button v-if="getProduct().key === 'classic'" :disabled="loading" type="primary" @click="batchOnline()" style="margin-left: 10px" >{{"自动排图"}}</el-button>
    <el-button
      type="warning"
      :disabled="loading || !selectedDayImages.length || selectedDayImages.every(image => image.cost > 0)"
      @click="batchSetSelectedDayImagesVideo"
      style="float: right; margin-right: 45px"
    >设为激励视频{{ selectedDayImages.length ? `(${selectedDayImages.length})` : '' }}</el-button>

    <vue-draggable-next v-model="dayImageList" :animation="300" handle=".handle" @change="sort">
      <transition-group>
        <div
          class="day-image-card"
          :class="{'is-selected': isDayImageSelected(image)}"
          v-for="image in dayImageList"
          :key="image.id"
        >
          <el-checkbox
            class="day-image-checkbox"
            :model-value="isDayImageSelected(image)"
            :disabled="loading"
            @change="toggleDayImageSelection(image)"
            @click.stop
          />
          <el-image style="cursor: pointer;display: block" lazy
                    :src="resourceUrl(image.thumbnail)" class="handle"></el-image>
          <video v-if="image.animation" :src="resourceUrl(image.animation)" controls muted playsinline class="handle" style="width: 140px; display: block; margin-top: 4px; cursor: move"></video>
          <b style="word-break: break-word">{{ image.id }}</b>
          <el-tag v-if="image.animation" size="small" type="success">动图</el-tag>
          <el-icon @click="offline(image)" size="20"
                   style="position: absolute; top: 5px; right: 5px;cursor: pointer;color: var(--el-color-danger)">
            <DeleteFilled/>
          </el-icon>
          <el-icon @click="updateVideo(image)" size="20" :color="'white'"
                   style="position: absolute;left: 10px;top: 110px;cursor: pointer">
            <VideoCamera v-if="image.cost > 0" />
            <!--            <Lock style="color: var(&#45;&#45;el-color-primary)" v-if="image.video"/>-->
            <!--                        <Unlock style="color: var(&#45;&#45;el-color-info)" v-else/>-->
          </el-icon>
        </div>
      </transition-group>
    </vue-draggable-next>
    <el-divider></el-divider>
    <div>
      <el-select :disabled="loading" v-model="query.category" clearable filterable style="width: 200px"
                 placeholder="分类">
        <el-option v-for="c in category_list" :label="`${c.i18n_name.EN}(${c.i18n_name.ZH_HANS})`"
                   :value="c.id"></el-option>
      </el-select>
      <!--            <el-select :disabled="loading" v-model="query.type" clearable style="width: 100px" placeholder="类型">-->
      <!--                <el-option v-for="(v, k) in $root.image_type_enum" :label="v" :value="parseInt(k)"></el-option>-->
      <!--            </el-select>-->
      <el-select :disabled="loading" v-model="query.video" clearable style="width: 100px" placeholder="激励视频">
        <el-option label="是" :value="true"></el-option>
        <el-option label="否" :value="false"></el-option>
      </el-select>
      <el-select :disabled="loading" v-model="query.is_animated" clearable style="width: 100px" placeholder="是否动图">
        <el-option label="是" :value="true"></el-option>
        <el-option label="否" :value="false"></el-option>
      </el-select>
      <el-select :disabled="loading" v-model="query.online" clearable style="width: 200px" placeholder="已选上线时间">
        <el-option label="是" :value="true"></el-option>
        <el-option label="否" :value="false"></el-option>
      </el-select>
      <el-input :disabled="loading" v-model="query.id" style="width: 100px" placeholder="ID"></el-input>
      <!--            <el-button type="success" :loading="loading" @click="fetchImages(1)">查询</el-button>-->
      <date-range-picker v-model="query" start-placeholder="上线开始时间" end-placeholder="上线结束时间"
                         :disabled="loading"></date-range-picker>
    </div>
    <el-table :data="dataPage" v-loading="loading" style="margin-top: 10px">
      <el-table-column label="ID" prop="id" width="250">
        <template #default="scope">
          <div>{{ scope.row.id }}</div>
          <div style="text-align: center">
            <a :href="resourceUrl(scope.row.resource)" target="_blank">查看原图</a>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="缩略图" prop="thumbnail" width="100">
        <template #default="scope">
          <el-image :src="resourceUrl(scope.row.thumbnail)" lazy style="width: 90px"></el-image>
        </template>
      </el-table-column>
      <el-table-column label="完成动图" prop="animation" width="100">
        <template #default="scope">
          <video v-if="scope.row.animation" :src="resourceUrl(scope.row.animation)" controls muted playsinline style="width: 90px"></video>
          <span v-else style="color: #999;">否</span>
        </template>
      </el-table-column>
      <el-table-column label="模块" prop="module" width="100">
        <template #default="scope">
          {{ $root.image_module_enum[scope.row.module] }}
        </template>
      </el-table-column>
<!--      <el-table-column label="分类" prop="categories" width="200">-->
<!--        <template #default="scope">-->
<!--          <template v-for="key in scope.row.categories">-->
<!--            <template v-for="c in category_list">-->
<!--              <el-tag v-if="c.key === key">{{ c.i18n_name.EN }}</el-tag>-->
<!--            </template>-->
<!--          </template>-->
<!--        </template>-->
<!--      </el-table-column>-->
      <el-table-column label="分类" prop="categories" width="200">
          <template #default="scope">
              <el-tag v-for="c in scope.row.categories">{{ category_map[c] }}</el-tag>
          </template>
      </el-table-column>
      <el-table-column label="激励视频" width="100">
        <template #default="scope">
          {{ scope.row.cost > 0 ? '是' : '' }}
        </template>
      </el-table-column>
      <el-table-column label="上线时间" prop="online_date" width="150">
        <!--              <template #default="scope">-->
        <!--                <el-date-picker style="width: 120px" value-format="YYYY-MM-DD" v-model="scope.row.online_date"-->
        <!--                                @change="update(scope.row)" :clearable="false"></el-date-picker>-->
        <!--              </template>-->
        <template #default="scope">
          {{ scope.row.online_date }}
        </template>
      </el-table-column>
      <el-table-column label="备注" prop="id" width="150"></el-table-column>
      <el-table-column label="业务占用" width="170">
        <template #default="scope">
          <el-tag v-if="scope.row.achievement_reward" type="warning" size="small">成就奖励，不可加入日更</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200">
        <template #default="scope">
          <el-button type="primary" size="small" :disabled="scope.row.achievement_reward || scope.row.online_date === this.selected_day || loading"
                     @click="online(scope.row)">{{ scope.row.achievement_reward ? '不可上线' : (scope.row.online_date === this.selected_day ? '已上线' : '上线') }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination layout="prev, pager, next" :total="total" @current-change="fetchImages"
                   :page-size="limit"></el-pagination>
    <template #footer>
      <el-button type="primary" @click="reset" :disabled="loading">关闭</el-button>
    </template>
  </el-dialog>
<!--    <el-table style="margin-top: 20px;" v-loading="loading" :data="dataPage">-->
<!--        <el-table-column label="ID" prop="id" width="130"></el-table-column>-->
<!--        <el-table-column label="状态" prop="status" width="100">-->
<!--            <template #default="scope">-->
<!--                <el-select :disabled="loading" style="width: 80px" v-model="scope.row.status"-->
<!--                           @change="update(scope.row)">-->
<!--                    <el-option label="通过" value="AUDITED"></el-option>-->
<!--                    <el-option label="审核中" value="AUDITING"></el-option>-->
<!--                    <el-option label="不通过" value="REJECTED"></el-option>-->
<!--                </el-select>-->
<!--            </template>-->
<!--        </el-table-column>-->
<!--        <el-table-column label="图片" prop="resource" width="200">-->
<!--            <template #default="scope">-->
<!--                <el-image lazy :src="`https://jigsaw-cdn.plutodesk.com/${scope.row.thumbnail}`" style="width: 180px"/>-->
<!--                <div style="text-align: center;">-->
<!--                    <a :href="`https://jigsaw-cdn.plutodesk.com/${scope.row.resource}`" target="_blank">高清大图</a>-->
<!--                </div>-->
<!--            </template>-->
<!--        </el-table-column>-->
<!--        <el-table-column label="价格" prop="cost" width="100">-->
<!--            <template #default="scope">-->
<!--                <el-select v-model="scope.row.cost" style="width: 80px" @change="update(scope.row)">-->
<!--                    <el-option :value="0"></el-option>-->
<!--                    <el-option :value="20"></el-option>-->
<!--                </el-select>-->
<!--            </template>-->
<!--        </el-table-column>-->
<!--        <el-table-column label="来源" prop="source" width="100"></el-table-column>-->
<!--        <el-table-column label="上线时间" prop="online_date" width="140">-->
<!--            <template #default="scope">-->
<!--                <el-date-picker style="width: 120px" value-format="YYYY-MM-DD" v-model="scope.row.online_date"-->
<!--                                @change="updateOnlineDate(scope.row)" :clearable="false"></el-date-picker>-->
<!--            </template>-->
<!--        </el-table-column>-->
<!--        <el-table-column label="分类" prop="categories" width="80">-->
<!--            <template #default="scope">-->
<!--                <el-tag v-for="c in scope.row.categories">{{ category_map[c] }}</el-tag>-->
<!--            </template>-->
<!--        </el-table-column>-->
<!--        <el-table-column label="主要标签" prop="major_tags" width="100">-->
<!--            <template #default="scope">-->
<!--                <el-tag v-for="t in scope.row.major_tags">{{ major_map[t] }}</el-tag>-->
<!--            </template>-->
<!--        </el-table-column>-->
<!--        <el-table-column label="次要标签" prop="minor_tags" width="100">-->
<!--            <template #default="scope">-->
<!--                <el-tag v-for="t in scope.row.minor_tags">{{ minor_map[t] }}</el-tag>-->
<!--            </template>-->
<!--        </el-table-column>-->
<!--        <el-table-column label="辅助标签" prop="assistant_tags" width="100">-->
<!--            <template #default="scope">-->
<!--                <el-tag v-for="t in scope.row.assistant_tags">{{ assistant_map[t] }}</el-tag>-->
<!--            </template>-->
<!--        </el-table-column>-->
<!--    </el-table>-->
<!--    <div style="display: flex; justify-content: space-between">-->
<!--        <el-pagination layout="prev, pager, next" :total="data.length" :page-size="size"-->
<!--                       v-model:current-page="page" :disabled="loading"></el-pagination>-->
<!--    </div>-->

<!--    <el-dialog v-model="dialog_opened" :before-close="reset" width="80%">-->
<!--        <el-select v-model="country" filterable :disabled="loading" clearable placeholder="全球">-->
<!--            <el-option v-for="c in $root.country_list" :value="c.code"-->
<!--                       :label="c.en_name + ' (' + c.code + ')'"></el-option>-->
<!--        </el-select>-->
<!--        <el-select v-model="platform" filterable placeholder="请选择平台" :disabled="loading" style="width: 140px; margin-left: 10px">-->
<!--          <el-option v-for="c in ['android', 'ios']" :value="c" :label="c"></el-option>-->
<!--        </el-select>-->
<!--        <vue-draggable-next v-model="imageList" :animation="300" handle=".handle">-->
<!--            <div v-for="l in imageList" style="margin: 5px;position: relative;display: inline-block"-->
<!--                 :class="l.include_country && l.include_country.length && !l.include_country.includes(country) || l.exclude_country && l.exclude_country.includes(country)?'':'handle'">-->

<!--                <el-image :src="`https://jigsaw-cdn.plutodesk.com/${l.thumbnail}`"-->
<!--                          style="width: 200px;cursor: pointer;"></el-image>-->
<!--                <div class="cover"-->
<!--                     v-if="l.include_country && l.include_country.length &&  !l.include_country.includes(country) || l.exclude_country && l.exclude_country.includes(country)-->
<!--                            || l.platform && l.platform !== platform"></div>-->
<!--                <el-icon v-if="l.cost> 0" style="position: absolute; top: 0; left: 3px;" :size="25" :color="'white'">-->
<!--                  <VideoCamera />-->
<!--                </el-icon>-->

<!--            </div>-->
<!--        </vue-draggable-next>-->
<!--        <template #footer>-->
<!--            <el-button @click="reset" :loading="loading">取消</el-button>-->
<!--            <el-button type="primary" :loading="loading" @click="submit">确定</el-button>-->
<!--        </template>-->
<!--    </el-dialog>-->
</template>

<script>
import axios from "ts-axios-new";
import {isEmpty, timestampToDate, update} from "../libs/utils";
import {VueDraggableNext} from 'vue-draggable-next'
import {getProduct} from "../libs/app";
import DateRangePicker from "../base/DateRangePicker.vue";
import {ElMessage} from "element-plus";
import {applyDailyUpdateOrder} from "../libs/dailyImageWorkflow.mjs";

export default {
    name: "Update",
    components: {DateRangePicker, VueDraggableNext},
    data() {
        return {
            data_map: {}, loading: false, dialog_opened: false, editing: null, list: [],
            category_list: [], major_list: [], minor_list: [], assistant_list: [], data: [], country: "GLOBAL",
            category_map: {}, major_map: {}, minor_map: {}, assistant_map: {}, platform: 'android',
            platform_list_map: {}, selected_day: null, sort_list_map: {},
            today: timestampToDate(Date.now()), date: new Date(),
            day_image_list: [],  image_list: [],  total: 0, page: 1, skip: 0, limit: 50,
            selectedDayImageIds: [],
            // page: 1, size: 20
            // page_data: [],
            query: this.createQuery(),
            form: {
              date: '',
            }

        }
    },
    methods: {
      getProduct,
        init() {
            this.loading = true;
            // const now = Date.now();
            // axios.get(`/cms/v1/image`, {
            //     params: {
            //         module: 'LIBRARY', limit: 10000, status: 'AUDITED', product: getProduct().key,
            //     }
            // }).then(res => {
            //     this.data = [];
            //     res.data.data.imageList.forEach(image => {
            //         if (image.online_date) {
            //             if (this.data_map[image.online_date]) {
            //                 this.data_map[image.online_date].push(image);
            //             } else {
            //                 this.data_map[image.online_date] = [image];
            //             }
            //         }
            //         if (!image.online_date || image.online_date > timestampToDate(now)) {
            //             this.data.push(image);
            //         }
            //         if(image.sorts != null) {
            //             image.sort_ios = image.sorts.ios
            //         }
            //         if(image.sort_ios === null || image.sort_ios === undefined) {
            //           image.sort_ios = image.sort
            //         }
            //     });
            //     this.data.sort(function (a, b) {
            //         if (a.online_date && b.online_date) {
            //             return a.online_date < b.online_date ? 1 : -1;
            //         } else if (!a.online_date) {
            //             return 1;
            //         } else {
            //             return -1
            //         }
            //     });
            //     for (let key in this.data_map) {
            //         this.data_map[key].sort(function (a, b) {
            //             return a.sort - b.sort;
            //         })
            //     }
            //     this.loading = false;
            // });
            const month = this.date.getMonth() + 1 + '';
            axios.get(`/cms/v1/image`, {
              params: {
                module: "LIBRARY",
                status: "AUDITED",
                start: `${this.date.getFullYear()}-${month.length > 1 ? month : '0' + month}-01`,
                // end: `${this.date.getFullYear()}-${month.length > 1 ? month : '0' + month}-31`,
                include_none_date: true,
                include_achievement_usage: true,
                products: getProduct().key,  // 改为 products 支持多选
              }
            }).then(res => {
              this.image_list = res.data.data.imageList;
              // this.total = res.data.data.total;
              this.formatData()
              this.total = this.imageList.length
              this.loading = false;
            })
        },
        formatData() {
          this.data_map = {}
          this.image_list.forEach(image => {
            if (image.online_date) {
              if (this.data_map[image.online_date]) {
                this.data_map[image.online_date].push(image);
              } else {
                this.data_map[image.online_date] = [image];
              }
            }
          });
          for (const date in this.data_map) {
            const images = this.data_map[date];
            if(images) {
              this.data_map[date] = images.sort(
                  (a, b) => (
                      this.getSort(a) - this.getSort(b)
                  )
              );
            }
          }
        },
        // openDialog(selected) {
        //     if (selected) {
        //         this.dialog_opened = true;
        //         this.platform_list_map = {}
        //         this.editing = selected;
        //         update(this.list, selected);
        //     }
        // },
        // reload() {
        //     this.data_map = {};
        //     this.data.forEach(image => {
        //         if (image.online_date && image.status === 'AUDITED') {
        //             if (this.data_map[image.online_date]) {
        //                 this.data_map[image.online_date].push(image);
        //             } else {
        //                 this.data_map[image.online_date] = [image];
        //             }
        //         }
        //     })
        // },
        // reset() {
        //   this.loading = this.dialog_opened = false;
        // },
        openDialog(day) {
          this.dialog_opened = true;
          this.sort_list_map = {}
          this.query = this.createQuery()
          this.selected_day = day;
          this.page = 1
          this.skip = 0
          this.day_image_list = []
          this.clearSelectedImages()
          this.total = 0
          if (this.data_map[day]) {
            this.day_image_list = this.data_map[day]
          }
          this.total = this.imageList.length
        },
        selectDate(value) {
          this.$refs.calendar.selectDate(value);
        },
        batchOnline() {
          axios.post(`/cms/v1/batch-online/image`, {date: this.selected_day}).then(_ => {
            this.reset()
            this.init()
          })
        },
        // update(row) {
        //     this.loading = true;
        //     axios.put(`/cms/v1/image/${row.id}`, row).then(res => {
        //         this.reload();
        //         this.loading = false;
        //     })
        // },
        update(row) {
          this.formatData()
          this.sort_list_map = {}
          axios.put(`/cms/v1/image/${row.id}`, row).then(_ => {
          })
        },
        // updateOnlineDate(row) {
        //   this.loading = true;
        //   axios.put(`/cms/v1/online/image/${row.id}`, { online_date: row.online_date}).then(res => {
        //     this.loading = false;
        //   })
        // },
        df(map, list) {
            list.forEach(l => {
                map[l.id] = l.name;
                if (l.children.length) {
                    this.df(map, l.children);
                }
            });
        },
        getSort(image) {
          return (image?.sorts?.[this.sortType()] ?? image?.sorts?.[this.fallbackSortType()] ?? image.sort ?? 0)
        },
        createQuery() {
          return {
            category:  null,
            module: "LIBRARY",
            online: null,
            video: null,
            is_animated: null,
            id: null,
            start: null,
            end: null,
          }
        },
        fetchImages(page) {
          this.skip = (page - 1) * this.limit;
          this.page = page
          this.total = this.imageList.length
        },
        reset() {
            this.dialog_opened = this.loading = false;
            this.editing = this.country = 'GLOBAL';
            this.clearSelectedImages();
        },
        // submit() {
        //     this.loading = true;
        //     const sort = [];
        //     this.imageList.forEach((d, i) => {
        //       sort.push(d.id)
        //       if(this.platform === 'ios') {
        //         d.sort_ios = i
        //       } else {
        //         d.sort = i
        //       }
        //     });
        //     axios.post(`/cms/v1/sort/image`, {sort, platform: this.platform}).then(_ => {
        //         update(this.editing, this.list);
        //         this.reset();
        //     });
        // },
        async online(image) {
          if (image.achievement_reward) {
            ElMessage.error('成就奖励图不能加入每日更新');
            return;
          }
          this.loading = true;
          const onlineDate = this.selected_day;
          try {
            await axios.put(`/cms/v1/online/image/${image.id}`, {product: getProduct().key, online_date: onlineDate});
            // 服务端确认成功后再更新日历，失败时保留原排期。
            const previousDate = image.online_date;
            if (previousDate && this.data_map[previousDate]) {
              this.data_map[previousDate] = this.data_map[previousDate].filter(i => i.id !== image.id);
            }
            image.online_date = onlineDate;
            this.data_map[onlineDate] = [...(this.data_map[onlineDate] || []), image];
            this.day_image_list = this.data_map[onlineDate];
            this.sort_list_map = {};
          } catch (err) {
            ElMessage.error(err?.response?.data?.status?.message || err?.response?.data?.message || err?.message || '上线失败');
          } finally {
            this.loading = false;
          }
        },
        offline(image) {
          this.loading = true;
          let online_date = image.online_date
          if (this.data_map[online_date]) {
            this.data_map[online_date] = this.data_map[online_date].filter(i => i.id !== image.id);
            this.day_image_list = this.data_map[online_date]
          }
          this.sort_list_map = {}
          image.online_date = null
          // image.online_dates[getProduct().key] = null
          axios.put(`/cms/v1/online/image/${image.id}`, {product: getProduct().key, online_date: null}).then(res => {
            // this.day_image_list.splice(this.day_image_list.indexOf(image), 1);
            this.loading = false;
          })
        },
        updateVideo(row) {
          this.loading = true;
          if (row.cost > 0) {
            row.cost = 0
          } else {
            row.cost = 20
          }
          // row.cost = !row.video;
          axios.put(`/cms/v1/image/${row.id}`, row).then(res => {
            this.loading = false;
          });
        },
        clearSelectedImages() {
          this.selectedDayImageIds = [];
        },
        dayImageSelectKey(image) {
          return String(image && image.id ? image.id : '');
        },
        isDayImageSelected(image) {
          const key = this.dayImageSelectKey(image);
          return !!key && this.selectedDayImageIds.includes(key);
        },
        toggleDayImageSelection(image) {
          const key = this.dayImageSelectKey(image);
          if (!key) return;
          if (this.selectedDayImageIds.includes(key)) {
            this.selectedDayImageIds = this.selectedDayImageIds.filter((id) => id !== key);
          } else {
            this.selectedDayImageIds = [...this.selectedDayImageIds, key];
          }
        },
        batchSetSelectedDayImagesVideo() {
          const ids = this.selectedDayImages
              .filter(image => image && image.cost <= 0)
              .map(image => image.id);
          if (!ids.length) {
            ElMessage.info('选中的已上线图片都已是激励视频');
            return;
          }
          this.loading = true;
          axios.post('/cms/v1/batch-tag', {
            ids,
            mode: 'add',
            cost: 20,
          }).then(_ => {
            const idSet = new Set(ids);
            this.image_list.forEach(image => {
              if (idSet.has(image.id)) {
                image.cost = 20;
              }
            });
            this.dayImageList.forEach(image => {
              if (idSet.has(image.id)) {
                image.cost = 20;
              }
            });
            ElMessage.success(`已将 ${ids.length} 张图片设为激励视频`);
          }).catch(err => {
            ElMessage.error(err?.response?.data?.status?.message || err?.response?.data?.message || err?.message || '设置激励视频失败');
          }).finally(() => {
            this.loading = false;
          });
        },
        resourceUrl(resource) {
          if (!resource) {
            return '';
          }
          if (/^https?:\/\//.test(resource)) {
            return resource;
          }
          const cdn = import.meta.env.VITE_CDN_URL || 'https://jigsaw-cdn.plutodesk.com';
          return `${cdn.replace(/\/$/, '')}/${resource}`;
        },
        sort() {
          this.loading = true;
          const sortType = this.sortType();
          const sort = applyDailyUpdateOrder(this.dayImageList, sortType);
          axios.post(`/cms/v1/sort/image`, {sort, sort_type: sortType}).then(res => {
            this.loading = false;
          })
        },
        sortType() {
          // if (getProduct().key === 'classic') {
          //   return this.platform + "-" + this.country;
          // } else {
            return getProduct().key + "-" + this.platform + "-" + this.country;
          // }
        },
        fallbackSortType() {
          // if (getProduct().key === 'classic') {
          //   return "android-GLOBAL";
          // } else {
            return getProduct().key + "-" + "android-GLOBAL";
          // }
        },
        dayImageList: {
          get() {
            if (!this.sort_list_map[this.sortType()]){
              const list = this.day_image_list.filter(
                  item => ( (item.platform === null || item.platform === undefined || item.platform === this.platform) &&
                      (!item.include_country || !item.include_country.length || item.include_country.includes(this.country)) &&
                      (!item.exclude_country || !item.exclude_country.length || !item.exclude_country.includes(this.country))));
              this.sort_list_map[this.sortType()] = list.sort(
                  (a, b) => (
                      this.getSort(a) - this.getSort(b)
                  )
              );
            }
            return this.sort_list_map[this.sortType()]
          },
          set(value) {
            this.sort_list_map[this.sortType()] = value
          }
        }
    },
    mounted() {
        this.loading = true;
        axios.all([
            axios.get(`/cms/v1/category`).then(res => {
                this.category_list = res.data.data.categoryList;
                this.category_list = this.category_list.filter(c => c.id)
                this.category_list.forEach(c => {
                    this.category_map[c.id] = c.i18n_name.ZH_HANS;
                })
            }),
            axios.get('/cms/v1/tag/major').then(res => {
                this.major_list = res.data.data.tagList;
                this.df(this.major_map, this.major_list);
            }),
            axios.get('/cms/v1/tag/minor').then(res => {
                this.minor_list = res.data.data.tagList;
                this.df(this.minor_map, this.minor_list);
            }),
            axios.get('/cms/v1/tag/assistant').then(res => {
                this.assistant_list = res.data.data.tagList;
                this.df(this.assistant_map, this.assistant_list);
            }),
        ]).then(_ => {
            this.init();
        })
    },
    computed: {
      dataPage() {
        return this.imageList.slice(this.skip, this.skip + this.limit)
      },
      selectedDayImages() {
        const selected = new Set(this.selectedDayImageIds || []);
        if (!selected.size) {
          return [];
        }
        return (this.dayImageList || []).filter((image) => selected.has(this.dayImageSelectKey(image)));
      },
      imageList() {
        return this.image_list.filter(
            // 普通选图隐藏奖励；精确 ID 查询保留占用信息，按钮禁止排期。
            item => (!item.achievement_reward || this.query.id === item.id) &&
                (item.platform === null || item.platform === undefined || item.platform === "" || item.platform === this.platform) &&
                (this.country==="GLOBAL" || !item.include_country || !item.include_country.length || item.include_country.includes(this.country)) &&
                (this.country==="GLOBAL" || !item.exclude_country || !item.exclude_country.length || !item.exclude_country.includes(this.country)) &&
                (!item.online_date || item.online_date > this.selected_day) &&
                (!this.query.module || item.module === this.query.module) &&
                (!this.query.category || (item.categories && item.categories.includes(this.query.category))) &&
                (!this.query.id || item.id === this.query.id) &&
                (!this.query.start || (item.online_date && item.online_date >= this.query.start)) &&
                (!this.query.end || (item.online_date && item.online_date <= this.query.end)) &&
                (!this.query.online || this.query.online && item.online_date && item.online_date < this.today || !this.query.online && (!item.online_date || item.online_date > this.today)) &&
                (this.query.video===null || (this.query.video && item.cost > 0 ) || (!this.query.video && !item.cost)) &&
                (this.query.is_animated===null || (this.query.is_animated && item.animation) || (!this.query.is_animated && !item.animation)))
            .sort((a, b) => {
              // const a_current = a.online_date === this.selected_day;
              // const b_current = b.online_date === this.selected_day;
              // if (a_current && !b_current) return -1;
              // if (!a_current && b_current) return 1;
              if (isEmpty(a.online_date) && isEmpty(b.online_date)) {
                return a.id < b.id
                // return (a?.sorts?.[this.sortType()] ?? a.sort ?? 0) - (b?.sorts?.[this.sortType()] ?? b.sort ?? 0);
              }
              if (isEmpty(a.online_date)) return -1;
              if (isEmpty(b.online_date)) return 1;
              if (a.online_date !== b.online_date) {
                return a.online_date < b.online_date ? -1 : 1;
              }
              return this.getSort(a) - this.getSort(b)
            });
      },
      dayImageList: {
        get() {
          if (!this.sort_list_map[this.sortType()]){
            const list = this.day_image_list.filter(
                item => ( (item.platform === null || item.platform === undefined || item.platform === this.platform) &&
                    (this.country==="GLOBAL" || !item.include_country || !item.include_country.length || item.include_country.includes(this.country)) &&
                    (this.country==="GLOBAL" || !item.exclude_country || !item.exclude_country.length || !item.exclude_country.includes(this.country))));
            this.sort_list_map[this.sortType()] = list.sort(
                (a, b) => (
                    this.getSort(a) - this.getSort(b)
                )
            );
          }
          return this.sort_list_map[this.sortType()]
        },
        set(value) {
          this.sort_list_map[this.sortType()] = value
        }
      }
        // dataPage() {
        //     return this.data.slice((this.page - 1) * this.size, this.page * this.size);
        // },
        //
        // imageList: {
        //   get() {
        //     if (!this.platform_list_map[this.platform]){
        //         const list = this.list.filter(
        //             item => item.platform === null || item.platform === undefined || item.platform === this.platform);
        //         if(this.platform === 'ios') {
        //             this.platform_list_map[this.platform] = list.sort((a, b) => (a?.sort_ios ?? 0) - (b?.sort_ios ?? 0));
        //         } else {
        //             this.platform_list_map[this.platform] = list.sort((a, b) => (a?.sort ?? 0) - (b?.sort ?? 0));
        //         }
        //     }
        //     return this.platform_list_map[this.platform]
        //   },
        //   set(value) {
        //     this.platform_list_map[this.platform] = value
        //   }
        // }
    },
    watch: {
      date(latest, previous) {
        if (latest.getMonth() < previous.getMonth() || latest.getFullYear() < previous.getFullYear()) {
          this.init();
        }
      },
      country(latest, previous) {
        this.sort_list_map = {}
        this.day_image_list.sort((a, b)=>(this.getSort(a) - this.getSort(b)));
      },
      platform(latest, previous) {
        this.sort_list_map = {}
        this.day_image_list.sort((a, b)=>( this.getSort(a) - this.getSort(b)));
      },
      query: {
        handler(newQuery, oldQuery) {
          this.fetchImages(1)
        },
        deep: true
      }
    }
}
</script>

<style scoped>
.cover {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    cursor: not-allowed;
    background-color: #FFF;
    opacity: 0.75;
}

.day-image-card {
  display: inline-block;
  position: relative;
  width: 140px;
  margin: 5px;
  border: 2px solid transparent;
  padding: 2px;
}

.day-image-card.is-selected {
  border-color: var(--el-color-warning);
}

.day-image-checkbox {
  position: absolute;
  top: 5px;
  left: 8px;
  z-index: 2;
  background: rgba(255, 255, 255, 0.85);
  border-radius: 4px;
}

.el-select {
  width: 200px;
}

.el-calendar ::v-deep(.el-calendar-day) {
  height: fit-content;
  width: 160px;
  min-height: var(--el-calendar-cell-width);
}

</style>
